import ResultTable from "../../components/table/ResultTable";
import HecRasHelper from "../../helpers/HecRasHelper";
import ResultHeader from "../../components/table/ResultHeader";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import ResultBody from "../../components/table/ResultBody";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import React from "react";
import SuperText from "../outputs/SuperText";
import {FilterTitle} from "../ShapeAttributeTable";

export default function CrossSectionSurveyPoints({item, onSurvCodeFilter, survCodeFilters}) {
    const is_green = (p, tobl, tobr) => {

    }

    const renderPointTable = (points) => {
        if (points?.length === 0) {
            return (
                <></>
            )
        }

        points.sort((a, b) => a?.station_us-b?.station_us)

        const codes = Array.from(new Set(points.map(p => p?.properties?.SURV_CODE?.trim())))
        codes.sort((a, b) => {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
            return 0;
        })

        const tobl = points.find(p => p?.properties?.SURV_CODE === 'TOBL') || {station_us: -99999}
        const tobr = points.find(p => p?.properties?.SURV_CODE === 'TOBR') || {station_us: -99999}

        let _points = [...points]
        if(survCodeFilters?.length > 0) {
            _points = points.filter(p => survCodeFilters.includes(p?.properties?.SURV_CODE))
        }

        return (
            <ResultTable style={{minWidth: HecRasHelper.getWidth(60)}}>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>SURVSTR ID</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>OBJECT ID</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(10)}}>
                            <FilterTitle
                                width={300}
                                treeData={codes.map(x => ({title: x, value: x, key: x}))}
                                prop={'SURV CODE'}
                                values={survCodeFilters || []}
                                onChangeFilters={(prop, values) => {
                                    onSurvCodeFilter && onSurvCodeFilter(prop, values)
                                }}
                            />
                        </ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>STATION</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>ELEV</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        _points.filter(x => x).map(p => {
                            return (
                                <ResultRow>
                                    <ResultHeaderCell
                                        style={{
                                            textAlign: 'start',
                                            width: HecRasHelper.getWidth(15)
                                        }}
                                    >
                                        {p?.properties?.SURVSTR_ID}
                                    </ResultHeaderCell>
                                    <ResultHeaderCell
                                        style={{
                                            textAlign: 'start',
                                            width: HecRasHelper.getWidth(15)
                                        }}
                                    >
                                        {p?.properties?.OBJECTID || p?.properties?.SURVPT_ID} {p?.footnotes?.includes(1) > 0 ? ` (Burned)` : ``}
                                    </ResultHeaderCell>
                                    <ResultHeaderCell
                                        style={{
                                            textAlign: 'start',
                                            width: HecRasHelper.getWidth(10),
                                            backgroundColor: tobl.station_us <= p?.station_us && p?.station_us <= tobr.station_us ? '#C0FFC8' :''
                                        }}
                                    >
                                        {p?.properties?.SURV_CODE_TEXT || p?.properties?.SURV_CODE}
                                    </ResultHeaderCell>
                                    <ResultBodyCell
                                        style={{
                                            textAlign: 'end',
                                            width: HecRasHelper.getWidth(10),
                                            backgroundColor: tobl.station_us <= p?.station_us && p?.station_us <= tobr.station_us ? '#C0FFC8' :''
                                        }}
                                    >
                                        {p?.station_us?.toFixed(2)}
                                    </ResultBodyCell>
                                    <ResultBodyCell
                                        style={{
                                            textAlign: 'end',
                                            width: HecRasHelper.getWidth(10),
                                            backgroundColor: tobl.station_us <= p?.station_us && p?.station_us <= tobr.station_us ? '#C0FFC8' :''
                                        }}
                                    >
                                        {p?.properties?.ELEV?.toFixed(2)}
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
        )
    }

    return (
        <>
            {renderPointTable(item?.dict?.point_list || [])}
        </>
    )
}